"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUnitsNameFromLabel = getUnitsNameFromLabel;
function getUnitsNameFromLabel(str) {
  return str.split(" ").map(function (word) {
    // Проверка, чтобы оставить слово, если оно состоит из смешанного регистра
    if (word !== word.toLowerCase() && word !== word.toUpperCase()) {
      return word;
    }
    // Проверяем, является ли слово аббревиатурой
    if (word === word.toUpperCase()) {
      return word; // Оставляем аббревиатуры как есть
    }
    // Делаем первую букву заглавной, а остальные — строчными
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(" ");
}